import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/AllocatePutAway';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const AllocatePutAway = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h6 style={{fontSize: 18, marginTop: 6, marginBottom: 12}} className="page-title-1">PUTAWAY - Allocate Task</h6>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

AllocatePutAway.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(AllocatePutAway);
